<script type="text/javascript">
	import Icon from "../icon.svelte";
	import {withdrawModal} from "../modal/modal.js";
	export let state;
</script>
<ul class="app_header-menu">
	{#if state >= 0}
	<li class:active={false}><a href="/my">
		<div class="icon"><Icon my/></div>
		<span >Мой аккаунт</span>
	</a></li>
	{/if}
	<li class:active={false}><a href="/">
		<div class="icon"><Icon accmagaz/></div>
		<span >Магазин аккаунтов</span>
	</a></li>
	<li class:active={false}><a href="/virts">
		<div class="icon"><Icon virtmagaz/></div>
		<span>Магазин виртов</span>
	</a></li>
	{#if state >= 0}
		<li class:active={false}><a href="/im">
			<div class="icon"><Icon msg /></div>
			<span>Сообщения</span>
		</a></li>
		<li class:active={false}><a href="/purchases">
			<div class="icon"><Icon boughtItems/></div>
			<span>Мои покупки</span>
		</a></li>
	{/if}
</ul>
<hr>
{#if state !== -1 && state < 1}
	<ul class="app_header-menu">
		<li class:active={false}><a href="/seller/start">
			<div class="icon"><Icon boughtItems/></div>
			<span>Продать товар</span>
		</a></li>
	</ul>
	<hr>
{/if}
{#if state >= 1}
	<ul class="app_header-menu">
		<li class:active={false}><a href="/seller/products/edit/-1">
			<div class="icon"><Icon boughtItems/></div>
			<span>Добавить товар</span>
		</a></li>
		<li class:active={false}><a href="/seller/products">
			<div class="icon"><Icon boughtItems/></div>
			<span>Мои товары</span>
		</a></li>
		<li class:active={false}><a href="/seller/disputes">
			<div class="icon"><Icon boughtItems/></div>
			<span>Управление спорами</span>
		</a></li>
		<li class:active={false}><a href="/seller/freez">
			<div class="icon"><Icon boughtItems/></div>
			<span>Заморозка баланса</span>
		</a></li>
		<li class:active={false}><a href="#" on:click={e=>withdrawModal()}>
			<div class="icon"><Icon boughtItems/></div>
			<span>Вывод средств</span>
		</a></li>
		<li class:active={false}><a href="/seller/virt/purchases">
			<div class="icon"><Icon boughtItems/></div>
			<span>Покупки виртов</span>
		</a></li>
	</ul>
	<hr>
{/if}
{#if state >= 2}
	<ul class="app_header-menu">
		<li class:active={false}><a href="/moder/verifyAccounts">
			<div class="icon"><Icon accmagaz/></div>
			<span>Проверка аккаунтов</span>
		</a></li>
	</ul>
	<hr>
{/if}
<ul class="app_header-menu">
	<li class:active={false}><a href="/articles">
		<div class="icon"><Icon menu/></div>
		<span>Статьи</span>
	</a></li>
	<li class:active={false}><a href="https://vk.com/tradestorehelp">
		<div class="icon"><Icon vk/></div>
		<span>Мы ВКонтакте</span>
	</a></li>
	<li class:active={false}><a href="https://t.me/tradestoresu">
		<div class="icon"><Icon telegram/></div>
		<span>Мы в Telegram</span>
	</a></li>
	<!--	<li class:active={false}><a href="#">
            <div class="icon"><Icon mail/></div>
            <span>Обратная связь</span>
        </a></li> -->
</ul>

<style type="text/css">
	div.icon{
		background: #252A30;
		border-radius: 4px;
		width: 34px;
		height: 34px;

		display: flex;
	}
	:global(div.icon > svg){
		color: white;
		margin: auto;
		width: 20px; height: 20px;
	}
	ul.app_header-menu{
		list-style: none;
	}
	ul.app_header-menu > li{
		margin-left: -40px;
		border-radius: 4px;
	}
	ul.app_header-menu > li > a{
		display: flex;
		align-items: center;
		color: white;
		text-decoration: none;
		font-size: 16px;
		color: rgba(255,255,255,.7);
		padding: 8px 5px;
	}
	ul.app_header-menu > li:not(:last-child){
		margin-bottom: 7px;
	}
	ul.app_header-menu > li > a > div.icon{
		margin-right: 14px;
	}

	ul.app_header-menu > li:hover{
		background: #252A30;
	}
	ul.app_header-menu > li.active > a > div.icon{
		background: #505760;
	}
	ul.app_header-menu > li.active > a > span{
		font-weight: #F0F0F0; font-weight: bold;
	}
</style>